<template>
    <div id="div1" class="systemDivClass">
        <el-menu :default-active="index" mode="horizontal" text-color="#fff">
            <template>
                <el-menu-item v-for="(value, i) in this.menuDataList" :index="value.menuId" :key="i" @click="pushLeftMenuTop(value, true)" class="menuStyle">
                    <img :key="i" :src="'.' + (value.menuIconUrl == '' ? beforeImgUrl : value.menuIconUrl) + '/' + menuImgUrl + value.menuIcon" v-if="value.menuIcon" class="imgClass" />
                    <i class=" el-icon-picture imgClass" v-else></i>
                    <span :title="value.menuName">{{ value.menuName }}</span>
                </el-menu-item>
            </template>
            <el-submenu v-if="isShowMoreMenu" index="20" active-text-color="red">
                <template slot="title">
                    <span class="el-icon-menu"></span>
                    <span>{{ $t('navbar.MORE_MENU') }} </span>
                </template>
                <el-menu-item :index="menu.menuId" v-for="(menu, index) in this.otherMenuList" @click="pushLeftMenuTop(menu, true)" :key="index" :href="menu.menuUrl">
                    <img :key="index" :src="'.' + (menu.menuIconUrl == '' ? beforeImgUrl : menu.menuIconUrl) + '/' + menuImgUrl + menu.menuIcon" v-if="menu.menuIcon" class="imgClass" />
                    <i class=" el-icon-picture imgClass" v-else></i>
                    <span :title="menu.menuName">{{ menu.menuName }}</span>
                </el-menu-item>
            </el-submenu>
        </el-menu>
    </div>
</template>
<script>
export default {
    props: {
        menuData: Array,
        topIndexId: String,
        pushLeftMenu: {
            type: Function,
            default: null
        },
        getDivLeft: {
            type: Function,
            default: null
        }
    },
    data() {
        return {
            menuDataList: [],
            maxMenuNum: 0,
            otherMenuList: [], // 其它菜单信息
            currentTopMenu: {}, // 当前选中一级菜单
            isShowMoreMenu: false,
            menuImgUrl: this.$store.state.skin + '/img/menu/',
            beforeImgUrl: '/skin',
            startIndex: 0,
            paddingLeft: 0,
            index: ''
        };
    },

    mounted() {
        const that = this;
        window.addEventListener('resize', function() {
            that.dealMenuInfo();
        });
        this.paddingLeft = window.$('#div1').offset().left;
        // this.dealMenuInfo();
        // this.beginMQSend();
    },

    methods: {
        // beginMQSend(){
        //     Api.beginMQSend();
        // },
        /* 处理菜单信息 */
        dealMenuInfo() {
            let divWidth = this.getDivLeft('#constom') - this.paddingLeft - 30;
            console.info(this.getDivLeft('#constom') + '---------' + this.paddingLeft);
            this.menuDataList = this.$util.clone(this.menuData);
            let showMenuNum = parseInt(divWidth / 125 - 1);
            if (this.menuDataList.length > showMenuNum + 1) {
                this.isShowMoreMenu = true;
                this.otherMenuList = this.menuDataList.slice(showMenuNum);
                this.menuDataList = this.menuDataList.splice(0, showMenuNum);
                this.startIndex = this.menuDataList.length;
            } else {
                this.isShowMoreMenu = false;
            }
        },
        pushLeftMenuTop: function(menu, isTop) {
            if (menu.menuUrl.search('event') >= 0) {
                let indexRex = menu.menuUrl.lastIndexOf(':');
                let event = menu.menuUrl.substring(indexRex + 1, menu.menuUrl.length);
                this.$EventBus.$emit(event, menu);
                return;
            }
            if (!isTop && menu == this.currentTopMenu) {
                return;
            } else {
                this.currentTopMenu = menu;
                window.vue.$store.state.topMenuIndex = menu.menuId;
                this.index = menu.menuId;
            }
            if (this.pushLeftMenu) {
                this.pushLeftMenu(menu);
            }
        },
        topIndex: function(topIndexId) {
            if (!topIndexId || this.index === topIndexId) {
                return;
            }
            let menu = window.vue.$common.topMenuObj;
            if (menu) {
                this.pushLeftMenuTop(menu);
            }
        }
    },
    watch: {
        topIndexId(newData, oldData) {
            this.index = newData;
        },
        '$store.state.topMenuIndex': 'topIndex'
    }
};
</script>
<style scopted>
.imgClass {
    margin-right: 7px;
}
.systemDivClass li {
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
}
</style>
